import {
  Airplane,
  Asterisk,
  BrokenShield,
  Danger,
  Pill,
  Shield,
  Suitcase,
  Clock,
} from '../components/assets/SvgComponents';

export const coverages = [
  {
    icon: Shield,
    title: 'UNLIMITED MEDICAL EXPENSES',
    description: 'There is no copayment, meaning no extra charges.',
    id: 'coverage_characteristic_0',
  },
  {
    icon: Airplane,
    title: 'MEDICAL REPATRIATION',
    description:
      'What if you get very sick or injured abroad? We will make sure to get you home in case of need so you can receive the best medical care.',
    id: 'coverage_characteristic_1',
  },
  {
    icon: Danger,
    title: 'ACCIDENTS',
    description:
      'If you get in an accident during your studies abroad, we will get you covered up to 30.000€ in case of death or permanent disability. <strong>*Even outside of your academic activities.</strong>',
    id: 'coverage_characteristic_2',
  },
  {
    icon: BrokenShield,
    title: 'PERSONAL LIABILITY',
    description:
      "If you damage something or hurt someone, we'll cover that too! <strong>*Even outside of your academic activities</strong>",
    id: 'coverage_characteristic_3',
  },
  {
    icon: Suitcase,
    title: 'LOST LUGGAGE AND DELAY IN DELIVERY',
    description:
      "We often lose control of our luggage, so it's important that you are covered for losses, delays in delivery...",
    id: 'coverage_characteristic_4',
  },
  {
    icon: Clock,
    title: 'TRIP DELAY AND CANCELLATION',
    description: 'Transport delays and cancellations are very common. Luckily we cover this, too.',
    id: 'coverage_characteristic_5',
  },
  {
    icon: Pill,
    title: 'Urgent delivery of medicines',
    description: "Forgot your medicines or can't get them where you are? No problem.",
    id: 'coverage_characteristic_6',
  },
  {
    icon: Asterisk,
    title: 'LEGAL ASSISTANCE',
    description:
      'Not everyone understands the law. In case you need to handle legal issues, our legal network will guide you with expert advice and connect you to local lawyers - or reimburse you if you need to find your own.',
    id: 'coverage_characteristic_7',
  },
];
